import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { 
  ISubmitMailOfferResponse,
} from 'api/curo/ApplyProcessApi';
import { ApplyFormFields, IApplyFormValues } from 'components/curo-components/forms/ApplyForm';
import {
  ContactInformationFields,
  IContactInformationFormValues,
} from 'components/curo-components/forms/ContactInformationForm/constants';
import { IWelcomeFormValues, WelcomeFormFields } from 'components/curo-components/forms/WelcomeForm';
import { submitMailOffer } from 'thunks';

import { resetCuroStore } from './actions';

export interface IApplyProcessState {
  welcomeProcessData: IWelcomeFormValues;
  applyProcessData: IApplyFormValues;
  contactInformationData: IContactInformationFormValues;
  mailOfferData?: ISubmitMailOfferResponse;
}

const initialState: IApplyProcessState = {
  welcomeProcessData: {
    [WelcomeFormFields.BorrowerZipOrPostalCode]: '',
    [WelcomeFormFields.BorrowerLast6DigitsSSN]: '',
    [WelcomeFormFields.BorrowerEmail]: '',
    [WelcomeFormFields.BorrowerPhone]: '',
    [WelcomeFormFields.TelephoneAndElectronicCommunicationPolicy]: false,
  },
  applyProcessData: {
    [ApplyFormFields.BorrowerFirstName]: '',
    [ApplyFormFields.BorrowerLastName]: '',
    [ApplyFormFields.BorrowerSSN]: '',
    [ApplyFormFields.BorrowerDateOfBirth]: '',
    [ApplyFormFields.BorrowerStreetAddress]: '',
    [ApplyFormFields.BorrowerCity]: '',
    [ApplyFormFields.BorrowerZipOrPostalCode]: '',
    [ApplyFormFields.BorrowerState]: '',
  },
  contactInformationData: {
    [ContactInformationFields.BorrowerEmail]: '',
    [ContactInformationFields.BorrowerPhone]: '',
    [ContactInformationFields.TelephoneAndElectronicCommunicationPolicy]: false,
  },
};

const applyProcessSlice = createSlice({
  name: 'applyProcess',
  initialState,
  reducers: {
    setWelcomeProcessData: (state, action: PayloadAction<IWelcomeFormValues>) => {
      state.welcomeProcessData = action.payload;
    },
    setApplyProcessData: (state, action: PayloadAction<IApplyFormValues>) => {
      state.applyProcessData = action.payload;
    },
    setContactInformationData: (state, action: PayloadAction<IContactInformationFormValues>) => {
      state.contactInformationData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetCuroStore, () => initialState);
    builder.addCase(submitMailOffer.fulfilled, (state, action) => {
      state.mailOfferData = action.payload;
    });
  },
});

export const { setWelcomeProcessData, setApplyProcessData, setContactInformationData } = applyProcessSlice.actions;
export default applyProcessSlice.reducer;
